import SettingsUserRow from './SettingsUserRow'

export default SettingsUserRow
